import React from 'react';
import { Typography } from '@mui/material';

function Projects() {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Proiectele mele
      </Typography>
      <Typography>
        Poți lista aici proiecte personale sau profesionale, cu linkuri către GitHub sau demo-uri live.
      </Typography>
    </>
  );
}

export default Projects;
